import {TableButtonOptions} from "../../Modules/ListPage/Components/Table/Buttons/TableButtonGroup";
import SiteConfig from "../Config/SiteConfig";
import DynamicCustomSelectorV2 from "../../Modules/FormPage/DynamicCustomSelectorV2";
import {UserCustomListSchema} from "./CustomSchemas/UserCustomListSchema";
import {UserIntegrationCustomSchema} from "./CustomSchemas/UserIntegrationCustomSchema";
import {CflowHorasListCustomSchema} from "../../Modules/CflowTimes/ApontamentoHoras/CflowHorasCustomSchema";
import {DinamicaSefazNfeCustomSchema} from "../../Modules/DinamicaSefaz/DinamicaSefazNfeCustomSchema";

export default class ListSchemaConfig {


    static REGISTERED_SCHEMA = {};

    static SCHEMA_CUSTOMIZATION = [
        UserCustomListSchema, UserIntegrationCustomSchema, CflowHorasListCustomSchema,
        DinamicaSefazNfeCustomSchema
        //    ,TenantCustomSchema

    ];


    async getSchema(name) {

        if (ListSchemaConfig.REGISTERED_SCHEMA[name]) {
            return ListSchemaConfig.REGISTERED_SCHEMA[name];
        }

        const siteConfigService = new SiteConfig();
        const siteConfig = await siteConfigService.getSiteConfig();
        const schema = siteConfig.listSchema[name] || {name};


        schema.getEndpoint = () => {
            return 'node/crud/entity/' + name;
        }

        schema.getColumns = () => {

            let columns = schema.schema;

            if (schema.canShowEditButton || schema.canShowDeleteButton) {

                const optionButton = TableButtonOptions({
                    deleteEndpoint: 'node/crud/entity/' + name,
                });

                columns.forEach(column => {

                    if (column.dynamicFilter) {
                        column.customFilterSelectorElement = DynamicCustomSelectorV2;
                        column.entitySchema = column.dynamicFilter.ref;
                    }

                });


                columns = [
                    optionButton,
                    ...columns
                ];

            }

            return columns;
        }

        ListSchemaConfig.SCHEMA_CUSTOMIZATION.forEach(custom => {
            custom(name, schema);
        });


        ListSchemaConfig.REGISTERED_SCHEMA[name] = schema;

        console.log('SCHEMA NEW LIST REGISTERED', schema);
        return schema;
    }


    async getListSchemaByName(name) {
        const schema = await this.getSchema(name);

        console.log('pageSchema.SCHEMA NEW LIST GET', schema);
        return schema;
    }

}
